import React from "react"
import Img from "../gatsbyImage/gatsbyImage"
import { LABEL_MAP } from "../../providers/article/articleLabel.data"
import { className as myClass } from "../articlePreview/articlePreview.className"
import {
  ArticleWrap,
  Article,
  ImageArea,
  TitleArea,
  TitleWrap,
  DateLabel,
  ArticleTitle,
  ContextArea,
  Context,
  ImgWrap,
  Hr,
} from "./articleList.style"
const ArticleList = ({ articles, className }) => {
  const ratio = 9 / 16
  return (
    <ArticleWrap className={className}>
      {articles.map(article => {
        const {
          id,
          path,
          title,
          excerpt,
          content,
          image,
          postingTime,
          label,
        } = article
        const { name, gradientColor } = LABEL_MAP.get(label)

        const postingDate = new Date(postingTime).toDateString()
        return (
          <Article key={id} to={`/article${path}`}>
            <ImageArea>
              <TitleArea className={myClass.titleArea} color={gradientColor}>
                <TitleWrap>
                  <DateLabel>{`${postingDate} · ${name}`}</DateLabel>
                  <Hr />
                  <ArticleTitle>{title}</ArticleTitle>
                </TitleWrap>
              </TitleArea>

              <ImgWrap className={myClass.image} width={`100%`} ratio={ratio}>
                <Img filename={image.filename} alt={image.alt} />
              </ImgWrap>
            </ImageArea>
            <ContextArea className={myClass.contextArea} color={gradientColor}>
              <Context
                className={myClass.context}
                dangerouslySetInnerHTML={{ __html: excerpt }}
              />
            </ContextArea>
          </Article>
        )
      })}
    </ArticleWrap>
  )
}

export default ArticleList
